// extracted by mini-css-extract-plugin
export var europeanChic = "styles-module--europeanChic--mHIjK";
export var headerContainer = "styles-module--headerContainer--NmP1S";
export var europeanChicGallery = "styles-module--europeanChicGallery--Xmqih";
export var europeanChicRow = "styles-module--europeanChicRow--+j+3X";